module.exports = __webpack_public_path__ + "img/photo-team1.8ece0242.jpg";